export const CONSTANT = {
  // DATE_FORMAT: "DD-MM-YYYY",
  DATE_FORMAT: "MM-DD-YYYY",
  TIME_FORMAT: "HH:mm",
  DATE_TIME_FORMAT: "DD-MM-YYYY HH:mm",
  POST_DATE_FORMAT: "YYYY-MM-DD",
  POST_TIME_FORMAT: "HH:mm",
  POST_DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm",
  DRAWER_TYPE: {
    ADD: "ADD",
    EDIT: "EDIT",
    VIEW: "VIEW",
  },

  PER_PAGE_RECORD: [
    { id: "5", value: "5 Per Page" },
    { id: "10", value: "10 Per Page" },
    { id: "50", value: "50 Per Page" },
    { id: "100", value: "100 Per Page" },
    { id: "500", value: "500 Per Page" },
    { id: "1000", value: "1000 Per Page" },
  ],
  IDEL_TIMEOUT_TIME: 1.5 * 60 * 60,
  TOKEN_EXPIRED_TIME: 1.5 * 60 * 60,
  TOKEN_REFRESH_TIME: 1.5 * 60 * 60,
  // IDEL_TIMEOUT_TIME: 2 * 60,
  // TOKEN_EXPIRED_TIME: 2 * 60,
  // TOKEN_REFRESH_TIME: 0.5 * 60,
};
export const BASE_URL = import.meta.env.VITE_REACT_APP_API_URL;

export const IMAGE_UPLOAD = import.meta.env.VITE_REACT_APP_IMAGE_API_URL;
//Dropdowns

export const genderOptions = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
  { id: 3, name: "Other" },
];

export const MAPS_API_KEY = import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY;
export const API_URL = import.meta.env.VITE_REACT_APP_API_URL;
export const SALT = 'IWNL';
export const CUSTOMER_ROLE = '3';


export const INDUSTRY_FILTER = {
  CAREER_CATEGORY: 1,
  SKILL_CATEGORY: 2,
  CAREER: 3,
  OCCUPATIONAL_GROUP: 4,
  CAREER_PATH: 5,
  CERTIFICATION: 6,
}


export const CurriculumFiles = [
  {
    name: "1-Hour ECN Lesson Plan",
    viewFile: "/curriculumFiles/1-hour-ecn-lesson-plan.pdf",
    downloadFile: "/curriculumFiles/1-hour-ecn-lesson-plan.pdf",
    downloadFileName: "1-hour-ecn-lesson-plan.pdf",
    id: "1-hour-ecn-lesson-plan"
  },
  {
    name: "1-Hour ECN Presentation",
    viewFile: "/curriculumFiles/1-hour-ecn-presentation.pdf",
    downloadFile: "/curriculumFiles/1-hour-ecn-presentation.pptx",
    downloadFileName: "1-hour-ecn-presentation.pptx",
    id: "1-hour-ecn-presentation"
  },
  {
    name: "3-Hour ECN Lesson Plan",
    viewFile: "/curriculumFiles/3-hour-ecn-lesson-plan.pdf",
    downloadFile: "/curriculumFiles/3-hour-ecn-lesson-plan.pdf",
    downloadFileName: "3-hour-ecn-lesson-plan.pdf",
    id: "3-hour-ecn-lesson-plan"
  },
  {
    name: "3-Hour ECN Presentation",
    viewFile: "/curriculumFiles/3-hour-ecn-presentation.pdf",
    downloadFile: "/curriculumFiles/3-hour-ecn-presentation.pptx",
    downloadFileName: "3-hour-ecn-presentation.pptx",
    id: "3-hour-ecn-presentation"
  },
  {
    name: "Counselor ECN Reference Sheet",
    viewFile: "/curriculumFiles/counselor-ecn-reference-sheet.pdf",
    downloadFile: "/curriculumFiles/counselor-ecn-reference-sheet.pdf",
    downloadFileName: "counselor-ecn-reference-sheet.pdf",
    id: "counselor-ecn-reference-sheet"
  },
  {
    name: "Facilitator ECN Reference Sheet",
    viewFile: "/curriculumFiles/facilitator-ecn-reference-sheet.pdf",
    downloadFile: "/curriculumFiles/facilitator-ecn-reference-sheet.pdf",
    downloadFileName: "facilitator-ecn-reference-sheet.pdf",
    id: "facilitator-ecn-reference-sheet"
  },
  {
    name: "Student ECN Career Planning Worksheet",
    viewFile: "/curriculumFiles/student-ecn-career-planning-worksheet.pdf",
    downloadFile: "/curriculumFiles/student-ecn-career-planning-worksheet.pdf",
    downloadFileName: "student-ecn-career-planning-worksheet.pdf",
    id: "student-ecn-career-planning-worksheet"
  },
];

